import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Hero from './components/Hero';
import Services from './components/Services';
import Portfolio from './components/Portfolio';
import Booking from './components/Booking';
import Contact from './components/Contact';
import Footer from './components/Footer';
import WhatsAppButton from './components/WhatsAppButton';
import PrivacyPolicy from './components/PrivacyPolicy';
import TermsOfService from './components/TermsOfService';
import CookiePolicy from './components/CookiePolicy';
import CookieConsentBanner from './components/CookieConsentBanner';
import BookingConfirmation from './components/BookingConfirmation';
import { initializeAnalyticsWithConsent, trackPageView } from './utils/analytics';
import { usePerformanceTracking } from './hooks/usePerformanceTracking';

// Main Home Page Component
const HomePage = () => (
  <>
    <Hero />
    <Services />
    <Portfolio />
    <Booking />
    <Contact />
  </>
);

function App() {
  // Initialize performance tracking
  usePerformanceTracking();

  useEffect(() => {
    // Initialize analytics when consent is given
    initializeAnalyticsWithConsent();
    
    // Track initial page view
    trackPageView(window.location.pathname, document.title);
  }, []);

  return (
    <Router>
      <div className="App">
        <Header />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<TermsOfService />} />
          <Route path="/cookies" element={<CookiePolicy />} />
          <Route path="/booking-confirmation/:bookingId" element={<BookingConfirmation />} />
        </Routes>
        <Footer />
        <WhatsAppButton />
        <CookieConsentBanner />
      </div>
    </Router>
  );
}

export default App;
